import { DEFAULT_LIMIT, MAX_LIMIT } from '../../../constants'
import { getCities, getLanguages, getOccupations, getSkills, getWorklocations } from '../../../services/resources'

export default {
  getCities ({ commit, state }) {
    return new Promise((resolve, reject) => {
      if (state.cities && state.cities.length) {
        resolve(state.cities)
        return
      }

      getCities()
        .then(response => {
          const cities = response.data
          commit('setCities', { cities })
          resolve(cities)
        })
        .catch(reject)
    })
  },

  getLanguages ({ commit }) {
    return new Promise((resolve, reject) => {
      getLanguages()
        .then(response => {
          const languages = response.data
          commit('setLanguages', { languages })
          resolve(languages)
        })
        .catch(reject)
    })
  },

  getOccupations ({ commit, state }) {
    let occupationOffset = 0

    return new Promise((resolve, reject) => {
      if (state.occupations && state.occupations.length) {
        resolve(state.occupations)
        return
      }

      const fetchOccupations = (offset = 0) => {
        getOccupations({
          limit: MAX_LIMIT,
          offset
        })
          .then(response => {
            const occupations = response.data

            occupationOffset += occupations.length
            commit('appendOccupations', { occupations })

            if (occupations.length > DEFAULT_LIMIT) {
              fetchOccupations(occupationOffset)
              return
            }

            resolve(state.occupations)
          })
          .catch(reject)
      }

      fetchOccupations()
    })
  },

  getSkills ({ commit }, params) {
    return new Promise((resolve, reject) => {
      getSkills(params)
        .then(response => {
          const skills = response.data
          commit('setSkills', { skills })
          resolve(skills)
        })
        .catch(reject)
    })
  },

  getWorklocations ({ commit }) {
    return new Promise((resolve, reject) => {
      getWorklocations()
        .then(response => {
          const worklocations = response.data
          commit('setWorklocations', { worklocations })
          resolve(worklocations)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/resources/actions.js